import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import MapView from "./MapView"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link , useParams, useNavigate, useSearchParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate} from "../../utils/helper";
import { selectStoredPermissions } from '../../stores/permissionsSlice';



const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [branches, setBranches] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const [view, setView] = useState("list");
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
   // Initialize state from URL params
    const [apiData, setApiData] = useState({
        search: searchParams.get('search') || "",
        daterange: searchParams.get('daterange') ? 
            JSON.parse(searchParams.get('daterange')) : '',
        page: parseInt(searchParams.get('page')) || 1,
    });

    // Update URL when filters change
    useEffect(() => {
        const params = new URLSearchParams();
        if (apiData.search) params.set('search', apiData.search);
        if (apiData.daterange) params.set('daterange', JSON.stringify(apiData.daterange));
        if (apiData.page > 1) params.set('page', apiData.page.toString());
        
        navigate(`?${params.toString()}`, { replace: true });
    }, [apiData.search, apiData.daterange, apiData.page,  navigate]);
    
    useEffect(() => {
        getBranches();
    }, [apiData.page, apiData.search, apiData.daterange,apiData.type]); // Dependency array for re-fetching data

    const getBranches = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "branches", // Replace with your API endpoint
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setBranches(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 1
        });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `branches/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getBranches();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };
    const cloneData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you want to clone this branch!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `branches-clone/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getBranches();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 

    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `branches/status/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getBranches();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                            Branches</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Branches</li>
                        </ul>
                    </div>
                    <div className="d-flex align-branches-center gap-2 gap-lg-3">
                        {/* Add New branches Button */}
                        { selectStoredPermissions().includes('create-branches') &&
                            <Link to={`/branches/create`}  className='btn btn-base btn-sm'>Add New Branch</Link>
                        }
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <div className="float-end">
                                    <button className={`btn btn-sm btn-secondary p-2 mx-1 ${view === 'list' ? 'active' : ''}`} onClick={() => setView('list')}> <i className='bi bi-view-list fs-3 '></i> </button>
                                    <button className={`btn btn-sm btn-secondary p-2 mx-1 ${view === 'map' ? 'active' : ''}`} onClick={() => setView('map')}> <i className='bi bi-geo-alt-fill fs-3'></i> </button>
                                </div>
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-branches-center position-relative mb-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder="Search Branch title.."/>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData?.daterange[0]}
                                                endDate={apiData?.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                maxDate={new Date()}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            {view === "list" ?(
                                <div id="kt_branches_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="table-responsive">
                                        <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                            <thead>
                                                <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                    <th>Branch Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Location</th>
                                                    <th>Status</th>
                                                    <th>Created Date</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="fw-semibold text-gray-600 fs-6">
                                                {branches.length > 0 ? branches.map((cat, index) => (
                                                    <tr key={index}>
                                                    
                                                        <td>{cat.name}</td>
                                                        <td>  {cat.email}</td>
                                                        <td>  {cat.phone}</td>
                                                        <td>  {cat.location}</td>
                                                        <td>
                                                            <div className="form-check form-switch mt-2">
                                                                <input className="form-check-input" type="checkbox" name="is_delivery" id="flexSwitchCheckChecked" checked={cat.status}  
                                                                onClick={() => updateStatus(cat._id)}/>
                                                            </div>
                                                            <button className="p-0 btn btn-transparent">
                                                                <span className={`badge ${cat.status ? 'badge-light-success' : 'badge-light-danger'}`} onClick={() => updateStatus(cat._id)} >
                                                                    {cat.status ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </button>
                                                        </td>
                                                        <td>  {formatDate(cat.createdAt,'DD MMM YYYY, hh:mm A')} </td>
                                                        <td className="mt-2">
                                                            <Link to={`/branches/${cat._id}`} className="btn btn-sm h-35px btn-light-primary m-1">
                                                                <i className="bi bi-eye-fill fs-6"></i>
                                                            </Link>
                                                            { selectStoredPermissions().includes('edit-branches') &&
                                                                <Link to={`/branches/create/${cat._id}`} className="btn btn-sm h-35px btn-light-primary m-1">
                                                                    <i className="bi bi-pencil-fill fs-6"></i>
                                                                </Link>
                                                            }
                                                            { selectStoredPermissions().includes('delete-branches') &&
                                                            <button  onClick={() => delData(cat._id)} className="btn btn-sm h-35px btn-light-primary m-1">
                                                                <i className="bi bi-trash-fill fs-6"></i>
                                                            </button>
                                                            }
                                                            { selectStoredPermissions().includes('edit-branches') &&
                                                                <button  onClick={() => cloneData(cat._id)} className="btn btn-sm h-35px btn-light-primary m-1">
                                                                    <i className="bi bi-copy fs-6"></i>
                                                                </button>
                                                            }
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> 
                                        {isLoader && (
                                            <Loader text="Loading" size="30" className="text-center"  />
                                        )}
                                        <span>Total Records: {pagination?.total_records}</span>


                                        {pagination.total_pages > 1 && (
                                            <Paginator
                                                page={pagination.current_page}
                                                rows={pagination.per_page}
                                                totalRecords={pagination.total_records}
                                                onPageChange={handlePageChange}
                                            />
                                        )}
                                    </div>
                                </div>
                            ):(
                                <MapView branches={branches} />
                            )}
                            


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
